__turbopack_context__.v({
  "category_name": "uuk5UW_category_name",
  "category_skills_item": "uuk5UW_category_skills_item",
  "title": "uuk5UW_title",
});
